exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mv-22 {\n  margin: 22px 0;\n}\n.v-middle {\n  vertical-align: middle !important;\n}\n.tab-content {\n  padding-bottom: 30px !important;\n}\n.selects_group > div {\n  padding-bottom: 10px;\n}\n.selects_group > div > select > option:first-child {\n  font-weight: bolder;\n}", ""]);

// exports
